import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import ResaleIcon from '@wix/da-ds/pkg/Icons/16x16/Resale';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './ResaleIndicator.scss';
const ResaleIndicator = ({ isResellable, className })=>{
    const { t } = useTranslation();
    if (isResellable) {
        // PM wants to remove this since by default its allowed for resale 99% of the time,
        // so it just creates noise
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], !isResellable && s['dim'], className)
    }, /*#__PURE__*/ React.createElement(ResaleIcon, {
        size: IconSize.SMALLER,
        role: "presentation"
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['text']
    }, t(isResellable ? 'sidebar.exclusives.resaleIndicator.allowed' : 'sidebar.exclusives.resaleIndicator.notAllowed')));
};
ResaleIndicator.displayName = 'ResaleIndicator';
export default ResaleIndicator;
